import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { WarningMessage } from '../../../../components/widgets';
import { getSectionAccessType } from '../../../../selectors/navigation';
import { SECTION_ACCESS_TYPES, SECTIONS } from '../../../../utils/consts';
import { partnerShape } from '../../types';
import css from '../PartnerConfigurationShelf.css';
import ParametersFactory from './ParametersFactory';

export const getParametersValidationSchema = parameters =>
    parameters.reduce(
        (total, { name }) => ({
            ...total,
            [name]: Yup.string()
                .nullable()
                .required('STATIC.REQUIRED_FIELD'),
        }),
        {}
    );

const PartnerParameters = ({ parameters, partner, isReadonly = false }) => {
    const sectionAccessType = useSelector(
        getSectionAccessType('new_partner_config', SECTIONS.PARTNER_CONFIGURATION_CREDENTIALS)
    );
    const hasViewAccess = sectionAccessType === SECTION_ACCESS_TYPES.VIEW;
    const disabled = hasViewAccess || isReadonly;

    // Sort parameters by their display index
    const sortedParameters = parameters.sort((a, b) => {
        return (a.displayIndex ?? Infinity) - (b.displayIndex ?? Infinity);
    });

    if (!sortedParameters.length) {
        return null;
    }

    return (
        <>
            <div className={css.title}>
                <Translate
                    id="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.PARTNER_PARAMETERS"
                    data={{ partnerName: partner.displayName }}
                />
            </div>
            {hasViewAccess && !isReadonly && (
                <WarningMessage
                    showIcon={false}
                    showSpacer={false}
                    type="permission"
                    message="STATIC.PAGES.PARTNER_CONFIGURATION.VIEW_ACCESS_ONLY"
                    className={css.viewAccessMessage}
                    textContainerClass={css.viewAccessMessageTextContainer}
                />
            )}
            <ParametersFactory parameters={sortedParameters} isReadonly={disabled} />
        </>
    );
};

PartnerParameters.propTypes = {
    parameters: PropTypes.array.isRequired,
    partner: partnerShape.isRequired,
    isReadonly: PropTypes.bool,
};

export default PartnerParameters;
